import React from "react";

export default function JS_Class_Inheritance() {
  return (
    <div className="tutorial-container">
      <h1>JS Class Inheritance</h1>
      <p>
        This tutorial explains the concept of JS Class Inheritance in JavaScript
        OOPs.
      </p>
    </div>
  );
}
